/**
 * Returns the first non-null provedor_* block from a workflow object.
 * Supports provedor_recuperacao, provedor_instalacao, and any future types.
 * @param {Object|null} workflow
 * @returns {Object|null}
 */
export const getProvedorAtivo = (workflow) => {
  if (!workflow) return null;
  const entry = Object.entries(workflow).find(
    ([k, v]) => k.startsWith('provedor_') && v !== null
  );
  return entry ? entry[1] : null;
};

/**
 * Returns the key name of the active provedor type (e.g. 'provedor_recuperacao').
 * Returns null if no active provedor is found.
 * @param {Object|null} workflow
 * @returns {string|null}
 */
export const getProvedorAtivoTipo = (workflow) => {
  if (!workflow) return null;
  const entry = Object.entries(workflow).find(
    ([k, v]) => k.startsWith('provedor_') && v !== null
  );
  return entry ? entry[0] : null;
};

/**
 * Returns the id of the active provedor block, or null if none found.
 * @param {Object|null} workflow
 * @returns {number|null}
 */
export const getProvedorAtivoId = (workflow) => getProvedorAtivo(workflow)?.id ?? null;
